import axios from "axios";
import { API_BASE_URL } from "./consts";

const api = (config) => {
  const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
  });

  return axiosInstance(config);
};

export default api;
